import type { NewsletterSignup } from '~/types';
import { BaseModel } from '~/models/base-model';

export class NewsletterSignupModel extends BaseModel<NewsletterSignup> {
    emailAddress = null;
}
